
import { defineComponent, onBeforeMount } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const store = useStore();

    document.title = process.env.VUE_APP_APP_NAME;

    onBeforeMount(() => {
      store.dispatch('restore');
    });
  },
});
